<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 患者干预档案
-->

<template>
  <div class="page-main">
    <div v-if="showTip != -1" class="tip">
      长按分享或保存图片
    </div>
    <div v-if="!url" class="info" id="reportCon">
      <div class="page-content">
        <div class="page-header">
          <div class="header-title">
            <span>{{ patientName }}的营养康复方案</span>
          </div>
          <div class="header-con">
            您好！结合您的身体状况制定了专属干预方案。在康复过程中，我们会持续关注您的恢复进展，适时为您优化调整方案细节：
          </div>
        </div>

        <div class="card-list">
          <div v-for="item in cardModules" data-item="item" :key="item">
            <div class="card-con" v-if="cardData[item.key] != null && cardData[item.key] != ''">
              <div class="card-border" :style="{ borderColor: item.color }">
                <div class="card-header">
                  <img class="b-icon" :src="item.icon" />
                  <span>{{ item.title }}</span>
                </div>
                
                <div v-html=" formatText(cardData[item.key]) " class="card-text" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div v-else class="img-box">
      <img :src="url" />
    </div>

  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import icon_1 from "../assets/intervenePlanTumor/c-icon-1.png"
import icon_2 from "../assets/intervenePlanTumor/c-icon-2.png"
import icon_3 from "../assets/intervenePlanTumor/c-icon-3.png"
import icon_4 from "../assets/intervenePlanTumor/c-icon-4.png"
import icon_5 from "../assets/intervenePlanTumor/c-icon-5.png"
import icon_6 from "../assets/intervenePlanTumor/c-icon-6.png"
import icon_7 from "../assets/intervenePlanTumor/c-icon-7.png"
import icon_8 from "../assets/intervenePlanTumor/c-icon-8.png"
import icon_9 from "../assets/intervenePlanTumor/c-icon-9.png"
export default {
  data() {
    return {
      url: '',
      showTip: -1,
      isPc: 0,
      patientName: "",

      cardData: [],
      cardModules: [{
        title: '目标摄入量',
        key: 'recommendedIntake',
        id: 1,
        color: "#5DAFF5",
        icon: icon_1,
        value: ""
      }, {
        title: '饮食原则',
        key: 'dietPrinciples',
        id: 2,
        color: "#FD955A",
        icon: icon_2,
      }, {
        title: '饮食方案',
        key: 'mealPlan',
        id: 4,
        color: "#3FDDB4",
        icon: icon_4,
      }, {
        title: '饮食禁忌',
        key: 'dietaryRestrictions',
        id: 5,
        color: "#FBB13D",
        icon: icon_5,
      }, {
        title: '食谱举例',
        key: 'dailyMenu',
        id: 6,
        color: "#9982FC",
        icon: icon_6,
      }, {
        title: '营养补充',
        key: 'enteralNutritionAdvice',
        id: 3,
        color: "#9982FC",
        icon: icon_3,
      }, {
        title: '运动',
        key: 'exerciseTips',
        id: 7,
        color: "#5EC9EF",
        icon: icon_7,
      }, {
        title: '心理',
        key: 'mentalHealthTips',
        id: 8,
        color: "#F86E6E",
        icon: icon_8,
      }, {
        title: '其他',
        key: 'other',
        id: 9,
        color: "#FBB13D",
        icon: icon_9,
      }]
    };
  },
  mounted() {
    this.id = getQueryString('id');
    this.showTip = getQueryString('showTip') || true;
    this.isPc = getQueryString('isPc');
    this.patientName = decodeURI(getQueryString('patientName', true));

    // this.id = "1894253833146880002";
    // this.patientName = "111";

    document.title = `干预方案`;

    this.getDetail()
  },

  methods: {

    getDetail() {
      let url = '/api/loss/interveneAi/selectInterveneDetail';
      if (this.isPc == 1) {
        url = '/api/loss/interveneAi/selectInterveneTemp'
      }
      ajax
        .Post({
          url: url,
          data: { id: this.id }
        }).then(({ data: { success, data = {} } }) => {
          if (success) {
            this.cardData = {...data} || {};
            console.log("data", data)
            setTimeout(() => {
              this.saveImg()
            }, 1000);
          }
        })
    },
    saveImg() {
      htmlToPDF('reportCon').then(url => {
        this.url = url
      });
    },
    formatText(text) {
      return text ? text.replace(/\n/g, '<br><br>') : '';
    }

  },
};
</script>

<style scoped>
html {
  font-size: 14px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.page-content {
  /*height: 100vh;*/
  /*overflow: auto;*/
  background-color: #fff;
}

.page-header {
  width: 100%;
  height: auto;
  padding: 16px 24px;
  background: #FBB13D;
}

.page-header .header-title {
  width: 100%;
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.page-header .header-title span {
  font-size: 20px;
  font-weight: 500;
  color: #fff;
}

.energy-box {
  font-size: 14px;
  color: #000000;
  height: 44px;
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 16px 0 0 16px;

}

.energy-box .energy {
  font-weight: 500;
  font-size: 20px;
  color: #FBB13D;
}

.page-header .header-con {
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  text-align: justify;
  margin-bottom: 18px;
}

.card-list {
  width: 100%;
  height: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  /* gap: 12px; */
}

.card-con {
  margin-bottom: 12px;
}

.card-list .card-con .card-border {
  width: 100%;
  /* min-height: 160px; */
  height: auto;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #3FDDB4;
  padding: 16px;
}

.menu-icon {
  width: 18px;
  height: 16px;
}

.card-list .card-con .card-border .card-header {
  display: flex;
  height: 20px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 16px;
}

.card-list .card-con .card-border .card-header span {
  flex: 1;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
}

.card-text {
  width: 100%;
  height: auto;
  font-size: 14px;
  line-height: 22px;
  color: #333;
  background: #FFF8F3;
  border-radius: 10px;
  padding: 12px;
}

.b-icon {
  width: 20px;
  height: 20px;
}

.a-icon {
  width: 14px;
  height: 14px;
}

.tip {
  color: #777;
  color: #FE5B59;
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  padding-bottom: 1rem;
  padding-top: 10px;
  background-color: #F6F7F8;
}

.img-box {
  width: 100%;
  height: auto;
}

.img-box img {
  width: 100%;
  height: auto;
}
</style>
